import { render, staticRenderFns } from "./OrderUpdateDeliveryModePage.vue?vue&type=template&id=2fda028b&scoped=true&"
import script from "./OrderUpdateDeliveryModePage.vue?vue&type=script&lang=ts&"
export * from "./OrderUpdateDeliveryModePage.vue?vue&type=script&lang=ts&"
import style0 from "./OrderUpdateDeliveryModePage.vue?vue&type=style&index=0&id=2fda028b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda028b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
